import AddLocationOutlinedIcon from '@mui/icons-material/AddLocationOutlined'
import ClearIcon from '@mui/icons-material/Clear'
import { Box, Button, IconButton } from '@mui/material'
import { useFieldArray, useFormContext } from 'react-hook-form'
import AddressSearch from './AddressSearch'

type StopsProps = { name: string; clientId: number }

const Stops = ({ name, clientId }: StopsProps) => {
  const { control } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  })

  return (
    <>
      {fields.map((field, index) => (
        <Box
          key={field.id}
          component="div"
          sx={{ display: 'flex', flexDirection: 'row', gap: '5px' }}
        >
          <AddressSearch
            control={control}
            clientId={clientId}
            name={`${name}.${index}`}
            id={`${name}.${index}`}
            label={`Stop ${index + 1}`}
          />
          <IconButton onClick={() => remove(index)}>
            <ClearIcon />
          </IconButton>
        </Box>
      ))}

      <Button
        onClick={() => append({})}
        startIcon={<AddLocationOutlinedIcon />}
        sx={{
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#ffffff',
          alignSelf: 'flex-end',
          paddingLeft: '10px',
          paddingRight: '10px',
        }}
      >
        Add Stop
      </Button>
    </>
  )
}

export default Stops
